"use client";

import { Loader2, Search } from "lucide-react";
import { SearchResultsContent } from "./SearchResults";
import type { GlobalSearch } from "./useGlobalSearch";

export function SearchBox({ s }: { s: GlobalSearch }) {
  const { query, results, searchLoading, paletteMode, activeIndex, searchInputRef, searchBoxRef, panelRef, shortcutLabel, flatItems, hasAnyResults, showResults, navigateTo, handleQueryChange, handleSearchKeyDown, setPaletteMode, setSearchOpen } = s;
  return (
        <div ref={searchBoxRef} className="relative hidden w-full justify-self-center md:block">
          <div className="flex items-center gap-2 rounded-full border border-line-strong bg-surface-raised px-4 py-2 focus-within:ring-2 focus-within:ring-accent focus-within:ring-offset-2 focus-within:ring-offset-page">
            {searchLoading ? (
              <Loader2 size={15} className="shrink-0 animate-spin text-subtle" />
            ) : (
              <Search size={15} className="shrink-0 text-subtle" />
            )}
            <input
              ref={searchInputRef}
              type="text"
              value={query}
              placeholder="Search the portal"
              aria-label="Search"
              className="w-full min-w-0 bg-transparent text-sm text-fg placeholder:text-subtle focus:outline-none focus-visible:ring-0 focus-visible:ring-offset-0"
              onChange={(e) => handleQueryChange(e.target.value)}
              onFocus={() => {
                setPaletteMode(false);
                setSearchOpen(true);
              }}
              onKeyDown={handleSearchKeyDown}
            />
            <kbd className="hidden shrink-0 rounded-md border border-line px-1.5 py-0.5 text-xs font-medium text-subtle sm:inline ">
              {shortcutLabel}
            </kbd>
          </div>

          {/* Inline dropdown — only when search was opened via this input
              itself, attached directly under it like a normal top search
              bar. The Alt+K palette (rendered separately, below) handles
              the other entry point with its own, differently-positioned
              panel. */}
          {showResults && !paletteMode && (
            <div
              ref={panelRef}
              className="absolute inset-x-0 top-full z-header mt-2 max-h-[60vh] overflow-y-auto rounded-xl border border-line bg-surface shadow-xl "
            >
              <SearchResultsContent
                results={results}
                flatItems={flatItems}
                activeIndex={activeIndex}
                onSelect={navigateTo}
                hasAnyResults={hasAnyResults}
                loading={searchLoading}
                query={query}
              />
            </div>
          )}
        </div>
  );
}
